import { httpClient } from "../../../shared/lib/api";
import {
	CallAvailabilityProductProps,
	QueryProps,
	RetrieveQueryProps,
} from "../types/query";

export class CallRequeryForbiddenError extends Error {
	constructor(message = "Essa consulta não pertence à sua empresa.") {
		super(message);
		this.name = "CallRequeryForbiddenError";
	}
}

export class CallRequeryNotFoundError extends Error {
	constructor(message = "Consulta não encontrada.") {
		super(message);
		this.name = "CallRequeryNotFoundError";
	}
}

export async function getCallAvailability(
	callId: string,
): Promise<CallAvailabilityProductProps[]> {
	const response = await httpClient.get(`call/availability/${callId}/`, {
		validateStatus: () => true,
	});

	if (response.status === 403) throw new CallRequeryForbiddenError();
	if (response.status === 404) throw new CallRequeryNotFoundError();

	const body = response.data as {
		content?: { products?: CallAvailabilityProductProps[] };
	};
	return body?.content?.products ?? [];
}

export async function requeryCall(callId: string): Promise<void> {
	const response = await httpClient.post(
		`call/requery/${callId}/`,
		{},
		{ validateStatus: () => true },
	);

	if (response.status === 403) throw new CallRequeryForbiddenError();
	if (response.status === 404) throw new CallRequeryNotFoundError();
	if (response.status !== 202) {
		throw new Error("Não foi possível iniciar a reconsulta.");
	}
}

export async function getCallStatus(callId: string): Promise<QueryProps> {
	const response = await httpClient.get(`call/retrieve/${callId}/`, {
		validateStatus: () => true,
	});

	if (response.status === 403) throw new CallRequeryForbiddenError();
	if (response.status === 404) throw new CallRequeryNotFoundError();
	if (response.status !== 200) {
		throw new Error("Não foi possível carregar a consulta.");
	}

	const body = response.data as RetrieveQueryProps;
	return body.content;
}
